import type { FC, ReactNode } from 'react'
import type { BlogSummary } from '@/types'

import Link from 'next/link'

import { formatDate } from '@/lib/format'

type InsightsProps = {
    posts: BlogSummary[]
    heading?: string
    subheading?: string
}

export const Insights: FC<InsightsProps> = ({
    posts,
    heading = 'Painting tips and guides',
    subheading = 'Learn from our 25+ years of experience. Tips, trends and guides to help you transform your space.'
}): ReactNode => {
    return (
        <section className='blog-section section-padding'>
            <div className='w-layout-blockcontainer container w-container'>
                <div className='section-content-wrapper'>
                    <div className='section-title-wrapper align-center' data-reveal>
                        <h2 className='section-title'>
                            {heading}
                        </h2>

                        <p className='section-subtitle blog'>
                            {subheading}
                        </p>
                    </div>

                    <div className='blog-collection-list-wrapper w-dyn-list'>
                        <div role='list' className='blog-list w-dyn-items' data-reveal-stagger='0.1'>
                            {posts.map((post) => (
                                <div key={post.id} role='listitem' className='w-dyn-item'>
                                    <Link
                                        href={`/blogs/${post.slug}`}
                                        className='single-blog w-inline-block'
                                    >
                                        <div className='blog-thumbnail-wrapper'>
                                            <img
                                                src={post.coverImage}
                                                loading='lazy'
                                                alt={post.coverImageAlt}
                                                className='blog-thumbnail'
                                            />
                                        </div>

                                        <div className='blog-content'>
                                            <div className='blog-title-wrapper'>
                                                <p
                                                    className='blog-title'
                                                    data-mdlfy-cms={`blog_posts:${post.id}:title`}
                                                >
                                                    {post.title}
                                                </p>

                                                <p className='blog-date'>
                                                    {formatDate(post.publishedOn)}
                                                </p>
                                            </div>

                                            <div className='blog-arrow-box'>
                                                <img
                                                    src='/images/arrow-up-right-3-1.svg'
                                                    loading='lazy'
                                                    alt=''
                                                    className='blog-arrow-icon'
                                                />

                                                <img
                                                    src='/images/arrow-up-right-3-1-1.svg'
                                                    loading='lazy'
                                                    alt=''
                                                    className='blog-arrow-icon hover'
                                                />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
